// =============================================================================
// 백업 오류 코드 → 사람이 읽는 설명 (2026-10-08 대교)
//
// 서버는 오류 코드와 영어 원문만 남긴다(비밀이 섞이지 않게 고정 문장). 화면과 백오피스 알림 메일은
// 이 표로 한국어 설명과 할 일을 붙인다. 코드를 추가하면 여기도 같이 채운다.
// =============================================================================

export type BackupErrorCodeKo =
  | 'BUSY' | 'INVALID_PATH' | 'MISSING_REFERENCE' | 'SOURCE_CHANGED' | 'CORRUPT_OBJECT' | 'INVALID_MANIFEST'
  | 'INVALID_SCHEMA' | 'INTEGRITY_FAILED' | 'INVALID_DESTINATION' | 'REMOTE_FAILED' | 'LOCAL_IO';

export const BACKUP_ERROR_KO: Record<BackupErrorCodeKo, { title: string; action: string }> = {
  BUSY: { title: '다른 백업이나 검증이 진행 중이라 이번 실행을 건너뛰었습니다.', action: '잠시 뒤 자동으로 다시 시도합니다.' },
  INVALID_PATH: { title: '백업 경로가 허용 범위를 벗어났습니다.', action: '서버의 백업·데이터 폴더 설정을 확인하세요.' },
  MISSING_REFERENCE: { title: 'DB가 가리키는 파일이 디스크에 없어 백업을 끝내지 못했습니다.', action: '빠진 원본 파일을 확인하세요. 썸네일은 자동으로 다시 만듭니다.' },
  SOURCE_CHANGED: { title: '백업하는 동안 원본 파일이 바뀌었습니다.', action: '다음 실행에서 자동으로 다시 시도합니다.' },
  CORRUPT_OBJECT: { title: '보관된 백업 파일의 해시가 맞지 않습니다.', action: '백업 검증을 실행하고 운영자에게 알리세요.' },
  INVALID_MANIFEST: { title: '백업 목록 파일이 손상돼 자동 정리를 멈췄습니다.', action: '백업 폴더의 sets 목록을 점검하세요.' },
  INVALID_SCHEMA: { title: 'DB의 파일 참조 형식을 읽을 수 없습니다.', action: '최근 스키마 변경을 확인하세요.' },
  INTEGRITY_FAILED: { title: '복원한 DB의 무결성 검사가 실패했습니다.', action: '다른 세대로 복구를 시도하고 운영자에게 알리세요.' },
  INVALID_DESTINATION: { title: '복구 대상 폴더가 비어 있지 않거나 운영 경로와 겹칩니다.', action: '빈 격리 폴더를 지정하세요.' },
  REMOTE_FAILED: { title: 'S3 업로드에 실패했습니다. 서버 안의 백업은 남아 있습니다.', action: '다음 실행에서 다시 올립니다. 계속되면 S3 권한·네트워크를 확인하세요.' },
  LOCAL_IO: { title: '서버 디스크나 DB 작업 중 오류가 났습니다.', action: '디스크 여유 공간과 서버 로그를 확인하세요.' },
};

/** 모르는 코드도 화면이 비지 않게 기본 문장을 돌려준다. */
export function describeBackupError(code: string): { title: string; action: string } {
  return (BACKUP_ERROR_KO as Record<string, { title: string; action: string }>)[code]
    ?? { title: '백업 중 알 수 없는 오류가 났습니다.', action: '서버 로그를 확인하세요.' };
}
